module.exports = __webpack_public_path__ + "img/icon-implantation-14.0d6a890b.svg";